<template>
    <div class="root" v-loading="loading">


        <topmenu></topmenu>




        <!-- content -->

        <div class="container theme-showcase">

            <div style="margin-top: 20px; display: flex; align-items: center;">
                <div style="flex:1;">
                    <el-button type="primary" icon="el-icon-plus" size="medium" @click="add">添加</el-button>
                </div>
                <div>
                    <el-button type="primary" icon="el-icon-refresh" size="medium" @click="refresh">刷新</el-button>
                </div>
            </div>

            <div style="margin: 16px 0;">
                <el-table :data="list" border style="width: 100%">
                    <el-table-column prop="index" label="序号" width="50">
                    </el-table-column>
                    <el-table-column prop="name" label="店名" width="180">
                    </el-table-column>
                    <el-table-column prop="tel" label="电话" width="120">
                    </el-table-column>
                    <el-table-column prop="address" label="地址">
                    </el-table-column>
                    <el-table-column prop="latlon" label="经纬度" width="100">
                    </el-table-column>
                    <el-table-column prop="lastupdatetime" label="编辑时间" width="140">
                    </el-table-column>
                    <el-table-column prop="ordering" label="序号" width="50">
                    </el-table-column>
                    <el-table-column label="操作" width="95">
                        <template slot-scope="scope">

                            <el-button size="mini" type="primary" icon="el-icon-edit" circle
                                @click="handleEdit(scope.$index, scope.row)"></el-button>
                            <el-button size="mini" type="danger" icon="el-icon-delete" circle
                                @click="handleDelete(scope.$index, scope.row)"></el-button>

                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin:12px 0;">
                    <div v-if="total > 1">
                        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
                            :current-page.sync="currentPage" :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>


            <el-dialog title="门店管理" :visible.sync="dialogFormVisible" width="650px">
                <el-form :model="form" label-width="80px">
                    <el-form-item label="店名:" required :error="nameErr">
                        <el-input v-model="Name" @change="nameChange"></el-input>
                    </el-form-item>
                    <el-form-item label="电话:" required :error="telErr">
                        <el-input v-model="Tel" @change="telChange"></el-input>
                    </el-form-item>
                    <el-form-item label="地址:" required :error="addressErr">
                        <el-input v-model="Address" @change="addressChange"></el-input>
                    </el-form-item>
                    <el-form-item label="经纬度:">
                        <div style="display: flex;">
                            <el-input v-model="Latlon" @change="latlonChange"></el-input>
                            <div style="margin-left: 12px;">
                                <el-button type="primary" @click.prevent="showmap">选择</el-button>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="序号:">
                        <el-input v-model="Ordering" @change="orderingChange"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="submit">确定</el-button>
                </div>
            </el-dialog>


            <div style="height: 35px;"></div>
        </div>
        <!-- content -->

    </div>
</template>

<script>

import axios from 'axios'
import topmenu from '../home/components/topmenu'

export default {
    name: 'catelist',
    data: function () {
        return {
            id: 0,
            eventId: '',
            eventList: [],
            btnDis: false,
            radioStep: '1',
            nickname: '',
            loading: false,
            list: [""],
            total: 2,
            dialogFormVisible: false,
            form: {},
            Name: '',
            nameErr: '',
            Tel: '',
            telErr: '',
            Address: '',
            addressErr: '',
            Latlon: '',
            Ordering: '',
            badgeList: [],
            IsDefault: false,
            BadgeTemplate: '',
            StartTime: '',
            EndTime: '',

            currentPage: 1,
        }
    },
    components: {
        topmenu
    },
    methods: {
        add() {
            this.dialogFormVisible = true;
            this.id = '';
            this.Name = '';
            this.Tel = '';
            this.Address = '';
            this.Latlon = '';
            this.Ordering = '';
        },
        goBack() {
            this.$router.back();
        },
        showmap() {
            console.log("showmap");
            var url = "http://jingweidu.757dy.com/";
            window.open(url);
        },
        submit() {
            if (this.Name == '') {
                this.nameErr = "请输入";
                return;
            } else {
                this.nameErr = "";
            }
            if (this.Tel == '') {
                this.telErr = "请输入";
                return;
            } else {
                this.telErr = "";
            }

            if (this.Address == '') {
                this.addressErr = "请输入";
                return;
            } else {
                this.addressErr = "";
            }
            this.onSubmit();
        },
        nameChange(val) {
            console.log(val);
            if (val != '' && val.length > 0) { this.nameErr = ''; }
            else {
                this.nameErr = "请输入";
            }
        },
        telChange(val) {
            console.log(val);
            if (val != '' && val.length > 0) { this.telErr = ''; }
            else {
                this.telErr = "请输入";
            }
        },
        addressChange(val) {
            console.log(val);
            if (val != '' && val.length > 0) { this.addressErr = ''; }
            else {
                this.addressErr = "请输入";
            }
        },
        orderingChange(val) {
            console.log(val);

        },
        latlonChange(val) {
            console.log(val);

        },
        onSubmit() {
            this.loading = true;
            this.btnDis = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));

            var uid = userJson.uid;
            var token = userJson.token;
            var url = 'api/Suggestion/CreateShop';
            if (this.id > 0) {
                url = 'api/Suggestion/UpdateShop';
            }
            axios.post(url,
                {
                    uid: uid,
                    token: token,
                    id: this.id,
                    name: this.Name,
                    tel: this.Tel,
                    address: this.Address,
                    latlon: this.Latlon,
                    ordering: this.Ordering
                }
            )
                .then(this.submitSucc)
        },
        submitSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.$message({
                    message: '操作成功!',
                    type: 'success',
                    onClose: () => {
                    }
                });
                this.dialogFormVisible = false;
                this.loadData(1);
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        refresh() {
            this.loadData(this.currentPage);
        },
        loadData(page) {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Suggestion/ShopList',
                {
                    skip: (page - 1) * 10,
                    limit: 10,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadDataSucc)
        },
        loadDataSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.total = res.total;
                this.list = res.list;
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        loadEvent() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/event/getList',
                {
                    limit: 10000,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadEventSucc)
        },
        loadEventSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                if (res.list && res.list.length > 0) {
                    this.eventList = res.list;
                    console.log(this.eventList);
                    if (this.eventId == '' || this.eventId == 0) {
                        this.eventId = res.list[0].id;
                    }
                    this.loadData(1);
                }
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        handleCommand(command) {
            if (command == 'logout') {
                localStorage.removeItem('userJson');
                this.$router.replace('/login');
            }
        },

        eventChange(id) {
            console.log(id);
            localStorage.setItem('eventId', id);
            this.currentPage = 1;
            this.loadData(1);
        },

        toeventlist() {
            this.$router.replace('/eventlist');
        },
        handleCurrentChange(page) {
            console.log(page)
            this.loadData(page);
        },
        handleDelete(index, row) {
            console.log(index, row);
            var id = row.id;
            console.log(id);

            this.$confirm('确定删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delCate(id);
            });

        },
        handleView(index, row) {
            console.log(index, row);
            var id = row.id;
            var eventId = row.eventId;
            this.$router.targe
        },
        handleEdit(index, row) {
            console.log(index, row);
            var id = row.id;
            console.log(id);
            this.id = id;
            this.Name = row.name;
            this.Tel = row.tel;
            this.Address = row.address;
            this.Latlon = row.latlon;
            this.Ordering = row.ordering;
            this.dialogFormVisible = true;
        },
        delCate(id) {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Suggestion/DeleteShop',
                {
                    id: id,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.delCateSucc)
        },
        delCateSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.loadData(this.currentPage);
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

    },
    mounted() {
        const id = this.$route.query.id;
        console.log(id)
        if (id != undefined && id != '') {

        }

        var eventId = localStorage.getItem('eventId');
        if (eventId != null && eventId != undefined) {
            eventId = parseInt(eventId);
            this.eventId = eventId;
        }

        // this.loadData(1);
        this.loadEvent();
        var userJson = JSON.parse(localStorage.getItem("userJson"));
        console.log(userJson);
        var nickname = userJson['nickname'];
        this.nickname = nickname;
        console.log(this.nickname);
    },
    beforeDestroy() {

    }
}
</script>
<style scoped>
.avatar-uploader>>>.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader>>>.el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
}

.avatar {
    width: 128px;
    display: block;
}

.root>>>.topmenuitem:nth-child(2) {
    color: #fff;
    background-color: #080808;
}
</style>



// WEBPACK FOOTER //
// src/pages/visitorcate/catelist.vue